// src/components/ProductGrid/ProductGrid.jsx
import React from 'react';
import { motion } from 'framer-motion';
import ProductCard from '../ProductCard/ProductCard';
import './ProductGrid.css';
import { FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const ProductGrid = ({ products, addToCart, title, viewAllLink }) => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <section className="product-grid-section">
      <div className="product-grid-container">
        {title && (
          <div className="product-grid-header">
            <motion.h2 
              className="section-title"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4 }}
            >
              {title}
            </motion.h2>
            {viewAllLink && (
              <motion.a 
                //href={viewAllLink} 
                className="view-all-link-wrapper"
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4 }}
              >
                
                <Link to="/shop" className="btne btn-primary hero-btn">
                  View All
                  <FiArrowRight className="arrow-icon" />
                </Link>
              </motion.a>
            )}
          </div>
        )}

        <motion.div 
          className="product-grid"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-50px" }}
        >
          {products && products.map(product => (
            <motion.div 
              key={product.id} 
              className="product-grid-item"
              variants={item}
              whileHover={{ y: -5 }}
            >
              <ProductCard product={product} addToCart={addToCart} />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ProductGrid;